/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plain_Text_Import_Max_Chars_HelpInputs */

const en_plain_text_import_max_chars_help = /** @type {(inputs: Plain_Text_Import_Max_Chars_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The maximum characters per line before creating a new line.`)
};

const fr_plain_text_import_max_chars_help = /** @type {(inputs: Plain_Text_Import_Max_Chars_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre maximal de caracteres par ligne avant de creer une nouvelle ligne.`)
};

const de_plain_text_import_max_chars_help = /** @type {(inputs: Plain_Text_Import_Max_Chars_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die maximale Anzahl an Zeichen pro Zeile, bevor eine neue Zeile erstellt wird.`)
};

const it_plain_text_import_max_chars_help = /** @type {(inputs: Plain_Text_Import_Max_Chars_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Numero massimo di caratteri per riga prima di creare una nuova riga.`)
};

const ru_plain_text_import_max_chars_help = /** @type {(inputs: Plain_Text_Import_Max_Chars_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Максимальное количество символов в строке до создания новой строки.`)
};

const es_plain_text_import_max_chars_help = /** @type {(inputs: Plain_Text_Import_Max_Chars_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El máximo de caracteres por línea antes de crear una nueva línea.`)
};

const zh_cn2_plain_text_import_max_chars_help = /** @type {(inputs: Plain_Text_Import_Max_Chars_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每行最多可包含 10 个字符，超过此数量将自动换行。`)
};

const ja_plain_text_import_max_chars_help = /** @type {(inputs: Plain_Text_Import_Max_Chars_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新しい行を作成する前の 1 行あたりの最大文字数。`)
};

const hi_plain_text_import_max_chars_help = /** @type {(inputs: Plain_Text_Import_Max_Chars_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नई पंक्ति बनाने से पहले प्रति पंक्ति अधिकतम वर्णों की संख्या।`)
};

const pt_pt2_plain_text_import_max_chars_help = /** @type {(inputs: Plain_Text_Import_Max_Chars_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Número máximo de caracteres por linha antes de criar uma nova linha.`)
};

/**
* | output |
* | --- |
* | "The maximum characters per line before creating a new line." |
*
* @param {Plain_Text_Import_Max_Chars_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const plain_text_import_max_chars_help = /** @type {((inputs?: Plain_Text_Import_Max_Chars_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plain_Text_Import_Max_Chars_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_plain_text_import_max_chars_help(inputs)
	if (locale === "de") return de_plain_text_import_max_chars_help(inputs)
	if (locale === "it") return it_plain_text_import_max_chars_help(inputs)
	if (locale === "ru") return ru_plain_text_import_max_chars_help(inputs)
	if (locale === "es") return es_plain_text_import_max_chars_help(inputs)
	if (locale === "zh-CN") return zh_cn2_plain_text_import_max_chars_help(inputs)
	if (locale === "ja") return ja_plain_text_import_max_chars_help(inputs)
	if (locale === "hi") return hi_plain_text_import_max_chars_help(inputs)
	if (locale === "pt-PT") return pt_pt2_plain_text_import_max_chars_help(inputs)
	return en_plain_text_import_max_chars_help(inputs)
});